'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _bluebird = require('bluebird');

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _matrixJsSdk = require('matrix-js-sdk');

var _MatrixClientPeg = require('./MatrixClientPeg');

var _MatrixClientPeg2 = _interopRequireDefault(_MatrixClientPeg);

var _Terms = require('./Terms');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IdentityAuthClient = function () {
    /**
     * Creates a new identity auth client
     * @param {string} identityUrl The URL to contact the identity server with.
     * When provided, this class will operate solely within memory, refusing to
     * persist any information such as tokens. Default null (not provided).
     */
    function IdentityAuthClient() {
        var identityUrl = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
        (0, _classCallCheck3.default)(this, IdentityAuthClient);

        this.accessToken = null;
        this.authEnabled = true;

        if (identityUrl) {
            // XXX: We shouldn't have to create a whole new MatrixClient just to
            // do identity server auth. The functions don't take an identity URL
            // though, and making all of them take one could lead to developer
            // confusion about what the idBaseUrl does on a client. Therefore, we
            // just make a new client and live with it.
            this.tempClient = (0, _matrixJsSdk.createClient)({
                baseUrl: "", // invalid by design
                idBaseUrl: identityUrl
            });
        } else {
            // Indicates that we're using the real client, not some workaround.
            this.tempClient = null;
        }
    }

    (0, _createClass3.default)(IdentityAuthClient, [{
        key: '_writeToken',
        value: function _writeToken() {
            if (this.tempClient) return; // temporary client: ignore
            window.localStorage.setItem("mx_is_access_token", this.accessToken);
        }
    }, {
        key: '_readToken',
        value: function _readToken() {
            if (this.tempClient) return null; // temporary client: ignore
            return window.localStorage.getItem("mx_is_access_token");
        }
    }, {
        key: 'hasCredentials',
        value: function hasCredentials() {
            return this.accessToken != null; // undef or null
        }

        // Returns a promise that resolves to the access_token string from the IS

    }, {
        key: 'getAccessToken',
        value: function () {
            var _ref = (0, _bluebird.coroutine)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
                var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                    _ref2$check = _ref2.check,
                    check = _ref2$check === undefined ? true : _ref2$check;

                var token;
                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                if (this.authEnabled) {
                                    _context.next = 2;
                                    break;
                                }

                                return _context.abrupt('return', null);

                            case 2:
                                token = this.accessToken;

                                if (!token) {
                                    token = this._readToken();
                                }

                                if (token) {
                                    _context.next = 10;
                                    break;
                                }

                                _context.next = 7;
                                return (0, _bluebird.resolve)(this.registerForToken(check));

                            case 7:
                                token = _context.sent;

                                if (token) {
                                    this.accessToken = token;
                                    this._writeToken();
                                }
                                return _context.abrupt('return', token);

                            case 10:
                                if (!check) {
                                    _context.next = 24;
                                    break;
                                }

                                _context.prev = 11;
                                _context.next = 14;
                                return (0, _bluebird.resolve)(this._checkToken(token));

                            case 14:
                                _context.next = 24;
                                break;

                            case 16:
                                _context.prev = 16;
                                _context.t0 = _context['catch'](11);

                                if (!(_context.t0 instanceof _Terms.TermsNotSignedError)) {
                                    _context.next = 20;
                                    break;
                                }

                                throw _context.t0;

                            case 20:
                                _context.next = 22;
                                return (0, _bluebird.resolve)(this.registerForToken());

                            case 22:
                                token = _context.sent;

                                if (token) {
                                    this.accessToken = token;
                                    this._writeToken();
                                }

                            case 24:
                                return _context.abrupt('return', token);

                            case 25:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this, [[11, 16]]);
            }));

            function getAccessToken(_x2) {
                return _ref.apply(this, arguments);
            }

            return getAccessToken;
        }()
    }, {
        key: '_checkToken',
        value: function () {
            var _ref3 = (0, _bluebird.coroutine)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(token) {
                return _regenerator2.default.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _context2.prev = 0;
                                _context2.next = 3;
                                return (0, _bluebird.resolve)(this._matrixClient.getIdentityAccount(token));

                            case 3:
                                _context2.next = 13;
                                break;

                            case 5:
                                _context2.prev = 5;
                                _context2.t0 = _context2['catch'](0);

                                if (!(_context2.t0.errcode === "M_TERMS_NOT_SIGNED")) {
                                    _context2.next = 12;
                                    break;
                                }

                                console.log("Identity Server requires new terms to be agreed to");
                                _context2.next = 11;
                                return (0, _bluebird.resolve)((0, _Terms.startTermsFlow)([new _Terms.Service(_matrixJsSdk.SERVICE_TYPES.IS, this._matrixClient.getIdentityServerUrl(), token)]));

                            case 11:
                                return _context2.abrupt('return');

                            case 12:
                                throw _context2.t0;

                            case 13:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this, [[0, 5]]);
            }));

            function _checkToken(_x4) {
                return _ref3.apply(this, arguments);
            }

            return _checkToken;
        }()
    }, {
        key: 'registerForToken',
        value: function () {
            var _ref4 = (0, _bluebird.coroutine)( /*#__PURE__*/_regenerator2.default.mark(function _callee3() {
                var check = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

                var hsOpenIdToken, _ref5, identityAccessToken;

                return _regenerator2.default.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                _context3.prev = 0;
                                _context3.next = 3;
                                return (0, _bluebird.resolve)(_MatrixClientPeg2.default.get().getOpenIdToken());

                            case 3:
                                hsOpenIdToken = _context3.sent;
                                _context3.next = 6;
                                return (0, _bluebird.resolve)(this._matrixClient.registerWithIdentityServer(hsOpenIdToken));

                            case 6:
                                _ref5 = _context3.sent;
                                identityAccessToken = _ref5.access_token;

                                if (!check) {
                                    _context3.next = 11;
                                    break;
                                }

                                _context3.next = 11;
                                return (0, _bluebird.resolve)(this._checkToken(identityAccessToken));

                            case 11:
                                return _context3.abrupt('return', identityAccessToken);

                            case 14:
                                _context3.prev = 14;
                                _context3.t0 = _context3['catch'](0);

                                if (!(_context3.t0.cors === "rejected" || _context3.t0.httpStatus === 404)) {
                                    _context3.next = 20;
                                    break;
                                }

                                // Assume IS only supports deprecated v1 API for now
                                // TODO: Remove this path once v2 is only supported version
                                // See https://github.com/vector-im/riot-web/issues/10443
                                console.warn("IS doesn't support v2 auth");
                                this.authEnabled = false;
                                return _context3.abrupt('return');

                            case 20:
                                throw _context3.t0;

                            case 21:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, this, [[0, 14]]);
            }));

            function registerForToken(_x5) {
                return _ref4.apply(this, arguments);
            }

            return registerForToken;
        }()
    }, {
        key: '_matrixClient',
        get: function get() {
            return this.tempClient ? this.tempClient : _MatrixClientPeg2.default.get();
        }
    }]);
    return IdentityAuthClient;
}(); /*
     Copyright 2019 The Matrix.org Foundation C.I.C.
     
     Licensed under the Apache License, Version 2.0 (the "License");
     you may not use this file except in compliance with the License.
     You may obtain a copy of the License at
     
         http://www.apache.org/licenses/LICENSE-2.0
     
     Unless required by applicable law or agreed to in writing, software
     distributed under the License is distributed on an "AS IS" BASIS,
     WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     See the License for the specific language governing permissions and
     limitations under the License.
     */

exports.default = IdentityAuthClient;
module.exports = exports['default'];
//# sourceMappingURL=IdentityAuthClient.js.map